/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Value_LabelInputs */

const en_us2_body_measures_value_label = /** @type {(inputs: Body_Measures_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measurement`)
};

const pt_br2_body_measures_value_label = /** @type {(inputs: Body_Measures_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medida`)
};

const es_419_body_measures_value_label = /** @type {(inputs: Body_Measures_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medida`)
};

const pt_pt2_body_measures_value_label = /** @type {(inputs: Body_Measures_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medida`)
};

const fr_fr2_body_measures_value_label = /** @type {(inputs: Body_Measures_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesure`)
};

const de_de2_body_measures_value_label = /** @type {(inputs: Body_Measures_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfang`)
};

const it_it2_body_measures_value_label = /** @type {(inputs: Body_Measures_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misura`)
};

/**
* | output |
* | --- |
* | "Measurement" |
*
* @param {Body_Measures_Value_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_value_label = /** @type {((inputs?: Body_Measures_Value_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Value_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_value_label(inputs)
	if (locale === "es-419") return es_419_body_measures_value_label(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_value_label(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_value_label(inputs)
	if (locale === "de-DE") return de_de2_body_measures_value_label(inputs)
	if (locale === "it-IT") return it_it2_body_measures_value_label(inputs)
	return en_us2_body_measures_value_label(inputs)
});
export { body_measures_value_label as "body-measures.value_label" }